import script from "./BaseAiButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseAiButton.vue?vue&type=script&setup=true&lang=ts"

import "./BaseAiButton.vue?vue&type=style&index=0&id=5c0a4574&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c0a4574"]])

export default __exports__